import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';

import AdsList from './AdsList';
import './ComparerTab.css';

class ComparerTab extends Component {
  state={
    height: '1000px',
  }

  componentDidMount() {
    const height = (((this.props.firstAds > this.props.secondAds) ? this.props.firstAds.length : this.props.secondAds.length) * 930) + 'px';
    this.setState({ height, [this.props.tabName + 'expandAll']: false, [this.props.tabName + 'Index']: '' });
  }

  handleExpandAll = () => {
    this.setState({ [this.props.tabName + 'expandAll']: !this.state[this.props.tabName + 'expandAll'] });
  }

  handleActiveIndex = (index) => {
    this.setState({ [this.props.tabName + 'Index']: index });
  }

  render() {
    return (
      <div>
        <strong>Expand all</strong>
        <Checkbox toggle onChange={this.handleExpandAll} checked={this.state[this.props.tabName + 'expandAll']} />
        <div className="left-list" style={{ height: this.state.height }}>
          <AdsList
            index={this.state[this.props.tabName + 'Index']}
            ads={this.props.firstAds}
            expandAll={this.state[this.props.tabName + 'expandAll']}
            handleActiveIndex={this.handleActiveIndex}
          />
        </div>
        <div className="right-list" style={{ height: this.state.height }}>
          <AdsList
            index={this.state[this.props.tabName + 'Index']}
            ads={this.props.secondAds}
            expandAll={this.state[this.props.tabName + 'expandAll']}
            handleActiveIndex={this.handleActiveIndex}
          />
        </div>
      </div>
    );
  }
}

export default ComparerTab;



// WEBPACK FOOTER //
// ./src/screens/AdComparer/ComparerTab.js